// 用户中心-协议中心
import _axios from "../../index";
import qs from 'qs'

//协议中心
export const signUser = data =>
    _axios({
        url: "sign/user",
        method: "get",
        params: data
    });
